import { useCallback, useLayoutEffect, useRef } from 'react'

const NEAR_BOTTOM_PX = 80

// Keeps a scroll container at its latest content — on first render and whenever
// `trigger` changes — unless the reader has scrolled up. `stick()` forces the
// next change to scroll (the user's own send).
export function useStickToBottom(trigger) {
  const node = useRef(null)
  const atBottom = useRef(true)

  // A callback ref: the list can mount later than the trigger changes (e.g. inside a dialog portal).
  const ref = useCallback((el) => {
    node.current = el
    if (el && atBottom.current) el.scrollTop = el.scrollHeight
  }, [])

  const onScroll = useCallback(() => {
    const el = node.current
    if (!el) return
    atBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight <= NEAR_BOTTOM_PX
  }, [])

  const scrollToBottom = useCallback(() => {
    const el = node.current
    if (el) el.scrollTop = el.scrollHeight
  }, [])

  const stick = useCallback(() => {
    atBottom.current = true
    scrollToBottom()
  }, [scrollToBottom])

  useLayoutEffect(() => {
    if (atBottom.current) scrollToBottom()
  }, [trigger, scrollToBottom])

  return { ref, onScroll, stick }
}

export default useStickToBottom
